import React from 'react';
import { ScreenController, TriggerProps } from 'src/feature-app';
import { ProspectsVentaForm } from 'src/forms';

export function ProspectsInPageTrigger(props: TriggerProps) {
	const renderTrigger = (Controller: JSX.Element) => {
		return (
			<>
				<ScreenController selectedJourney={Controller} closeLayerCallback={close} handleAreYouSureLayer={() => null} notALayer formType="inPage" />
			</>
		);
	};

	return renderTrigger(<ProspectsVentaForm inPage />);
}
